import { FC } from 'react'
import MenuItemQrCodeCard from "./MenuItemQrCodeCard";

import type { MenuItem } from "../../../types/menuItemTypes";
import type { MenuSection } from '../../../types/menuSectionTypes';
import type { Menu } from '../../../types/menuTypes';

type MenuItemQrCodeGridProps = {
  sectionsWithItems: { 
    section: MenuSection | null; 
    items: MenuItem[];
  }[];
  menu: Menu
};

const MenuItemQrCodeGrid: FC<MenuItemQrCodeGridProps> = ({ sectionsWithItems, menu }) => {
  const hasSections = sectionsWithItems.some((s) => s.section !== null && s.items.length > 0);  
  return (
    <div className='flex flex-col mx-2 lg:mx-10 pb-6'>
        {
        hasSections ? (
          sectionsWithItems.map((sectionWithItems) => (
            <div 
              key={`section-${sectionWithItems.section?.id}`}
              id={`section-${sectionWithItems.section?.id}`}
            >
              <h3 
                className="text-lg my-5 font-semibold text-center 
                  border-gray-200 dark:border-gray-800 dark:bg-gray-900 border
                  dark:bg-white/[0.03] dark:text-white/[0.8] rounded-lg p-2"
                >
                  {sectionWithItems.section?.name}
              </h3>
              <div 
                className="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-4" 
                key={sectionWithItems.section?.id}
              >
                {sectionWithItems.items.map((mi) => <MenuItemQrCodeCard menu={menu} key={mi.id} menuItem={mi} />)}  
              </div>
            </div>
          ))) : (
            <div 
              className="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-4" 
            >
              {sectionsWithItems[0].items.map((mi) => <MenuItemQrCodeCard menu={menu} key={mi.id} menuItem={mi} />)}  
            </div>
          )  
        }
    </div>
  );
}

export default MenuItemQrCodeGrid;
